var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addfirware" },
    [
      _c(
        "el-form",
        {
          ref: "data",
          attrs: {
            model: _vm.data,
            rules: _vm.rulesadd,
            "status-icon": true,
            "show-message": false,
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-right": "8px" },
              attrs: {
                label: "系统: ",
                "label-width": _vm.formLabelWidth,
                prop: "type",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "selectWidth",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  on: {
                    change: function ($event) {
                      return _vm.getversions()
                    },
                  },
                  model: {
                    value: _vm.data.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "type", $$v)
                    },
                    expression: "data.type",
                  },
                },
                _vm._l(_vm.system, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.valueCn, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-right": "8px" },
              attrs: {
                label: "任务类型: ",
                "label-width": _vm.formLabelWidth,
                prop: "taskType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "selectWidth",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.data.taskType,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "taskType", $$v)
                    },
                    expression: "data.taskType",
                  },
                },
                _vm._l(_vm.taskTypes, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.valueCn, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.versionflag
            ? _c(
                "el-form-item",
                {
                  staticStyle: { "padding-left": "8px" },
                  attrs: {
                    label: "版本号: ",
                    "label-width": _vm.formLabelWidth,
                    prop: "firmwareVersion",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selectWidth",
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "请选择" },
                      on: {
                        focus: function ($event) {
                          return _vm.getVersion()
                        },
                      },
                      model: {
                        value: _vm.data.firmwareVersion,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "firmwareVersion", $$v)
                        },
                        expression: "data.firmwareVersion",
                      },
                    },
                    _vm._l(_vm.versionData, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.versionflags
            ? _c(
                "el-form-item",
                {
                  staticStyle: { "padding-left": "8px" },
                  attrs: {
                    label: "版本号: ",
                    "label-width": _vm.formLabelWidth,
                    prop: "firmwareVersion",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.data.firmwareVersion,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "firmwareVersion", $$v)
                      },
                      expression: "data.firmwareVersion",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "中文: ",
                "label-width": _vm.formLabelWidth,
                prop: "cnFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _vm._v("\n        >\n        "),
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.cnFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "cnFixPoint", $$v)
                  },
                  expression: "data.cnFixPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "英文: ",
                "label-width": _vm.formLabelWidth,
                prop: "enFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _vm._v("\n        >\n        "),
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.enFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "enFixPoint", $$v)
                  },
                  expression: "data.enFixPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "繁体: ",
                "label-width": _vm.formLabelWidth,
                prop: "hkFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _vm._v("\n        >\n        "),
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.hkFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "hkFixPoint", $$v)
                  },
                  expression: "data.hkFixPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "日文: ",
                "label-width": _vm.formLabelWidth,
                prop: "jpFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _vm._v("\n        >\n        "),
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.jpFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "jpFixPoint", $$v)
                  },
                  expression: "data.jpFixPoint",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isDisable },
              on: { click: _vm.submit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }